import React, { useState } from "react";
import TeamAvatar from "../Assets/tableImg.png";

const SelectDropDown = ({ isAssigned }) => {
  const [open, setOpen] = useState(false);

  return (
    <div>
      <button className="text-sm text-red-600" onClick={() => setOpen(!open)}>
        {isAssigned ? (
          <div className="flex items-center rounded cursor-pointer">
            <img src={TeamAvatar} className="w-6 h-6 rounded-md" />
            <label
              htmlFor="checkbox-item"
              className="w-full py-2 ml-2 text-sm font-medium text-gray-900 rounded cursor-pointer"
            >
              AI Team Name
            </label>
          </div>
        ) : (
          "Select Team"
        )}
      </button>
      {open && (
        <div
          id="dropdownSearch"
          className="z-10 bg-white rounded-lg shadow w-60 pt-2 absolute mt-2"
          onClick={(e) => e.stopPropagation()}
        >
          <div className="pl-2 pr-4 flex items-center justify-between">
            <span className="text-gray-900 text-md">Select Team</span>
            <button onClick={() => setOpen(false)}>
              <svg
                width={13}
                height={13}
                viewBox="0 0 13 13"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M0.293031 0.967349C0.480558 0.785605 0.734866 0.683507 1.00003 0.683507C1.26519 0.683507 1.5195 0.785605 1.70703 0.967349L6.00003 5.1292L10.293 0.967349C10.3853 0.874756 10.4956 0.800901 10.6176 0.750093C10.7396 0.699285 10.8709 0.672542 11.0036 0.671423C11.1364 0.670305 11.2681 0.694833 11.391 0.743578C11.5139 0.792323 11.6255 0.864308 11.7194 0.955332C11.8133 1.04636 11.8876 1.1546 11.9379 1.27374C11.9881 1.39288 12.0134 1.52054 12.0123 1.64926C12.0111 1.77798 11.9835 1.90519 11.9311 2.02347C11.8787 2.14175 11.8025 2.24872 11.707 2.33815L7.41403 6.5L11.707 10.6618C11.8892 10.8447 11.99 11.0896 11.9877 11.3438C11.9854 11.5979 11.8803 11.8411 11.6948 12.0208C11.5094 12.2006 11.2586 12.3025 10.9964 12.3048C10.7342 12.307 10.4816 12.2092 10.293 12.0327L6.00003 7.8708L1.70703 12.0327C1.51843 12.2092 1.26583 12.307 1.00363 12.3048C0.741432 12.3025 0.49062 12.2006 0.305212 12.0208C0.119804 11.8411 0.0146347 11.5979 0.0123563 11.3438C0.0100779 11.0896 0.110873 10.8447 0.293031 10.6618L4.58603 6.5L0.293031 2.33815C0.10556 2.15635 0.000244141 1.90981 0.000244141 1.65275C0.000244141 1.39569 0.10556 1.14915 0.293031 0.967349Z"
                  fill="#6B7280"
                />
              </svg>
            </button>
          </div>
          <div className="p-3 pt-3">
            <label htmlFor="input-group-search" className="sr-only">
              Search
            </label>
            <div className="relative">
              <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                <svg
                  className="w-4 h-4 text-gray-500 dark:text-gray-400"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 20 20"
                >
                  <path
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z"
                  />
                </svg>
              </div>
              <input
                type="text"
                id="input-group-search"
                className="block w-full p-2 pl-10 text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500"
                placeholder="Search"
              />
            </div>
          </div>
          <div className="px-3 pb-3 max-h-[12rem] overflow-y-scroll">
            <span className="text-gray-900 ml-2 text-sm font-medium">
              All Available Teams
            </span>
            <ul
              className="text-sm text-gray-700 divide-y-2 pt-2"
              aria-labelledby="dropdownSearchButton"
            >
              {[0, 1, 2, 3, 4, 5, 6, 7, 8].map((item) => {
                return (
                  <li>
                    <div className="flex items-center pl-2 py-1 rounded cursor-pointer hover:bg-gray-50">
                      <input
                        id="checkbox-item"
                        name="checkbox-item"
                        type="radio"
                        defaultValue
                        className="w-5 h-5 accent-red-800"
                      />
                      <img
                        src={TeamAvatar}
                        className="w-6 h-6 rounded-md ml-2"
                      />
                      <label
                        htmlFor="checkbox-item"
                        className="w-full py-2 ml-2 text-sm font-medium text-gray-900 rounded cursor-pointer"
                      >
                        AI Team Name
                      </label>
                    </div>
                  </li>
                );
              })}
            </ul>
          </div>
          <div className="p-2 w-full border-t">
            <button className="bg-[#942A27] py-2 w-full rounded-md text-sm text-white font-medium">
              Confirm
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

const ProjectsTable = ({ isAssigned }) => {
  const [dialogOpen, setDialogOpen] = useState(null);

  return (
    <div className="w-full shadow-md my-3 rounded-xl overflow-hidden">
      <table className="w-full text-sm text-left text-gray-500">
        <thead className="text-xs text-gray-700 uppercase bg-white border-b">
          <tr>
            <th scope="col" className="p-4 capatalize">
              <div className="flex items-center">
                <input
                  id="checkbox-all-search"
                  type="checkbox"
                  className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-2"
                />
                <label htmlFor="checkbox-all-search" className="sr-only">
                  checkbox
                </label>
              </div>
            </th>
            <th scope="col" className="px-6 py-3 capatalize text-gray-500">
              Project
            </th>
            <th scope="col" className="px-6 py-3 capatalize text-gray-500">
              Due Date
            </th>
            <th scope="col" className="px-2 py-3 capatalize text-gray-500">
              Assign To
            </th>
            <th scope="col" className="px-6 py-3"></th>
            <th scope="col" className="px-6 py-3 capatalize text-gray-500">
              Days remaining
            </th>
            <th scope="col" className="px-6 py-3 capatalize text-gray-500">
              Stage
            </th>
            <th scope="col" className="px-6 py-3"></th>
          </tr>
        </thead>
        <tbody>
          {[0, 1, 2, 3, 4, 5, 6].map((tableRow, index) => {
            return (
              <tr className="bg-white border-b cursor-pointer hover:bg-gray-50">
                <td className="w-4 p-4">
                  <div className="flex items-center">
                    <input
                      id="checkbox-table-search-1"
                      type="checkbox"
                      className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-2"
                    />
                    <label
                      htmlFor="checkbox-table-search-1"
                      className="sr-only"
                    >
                      checkbox
                    </label>
                  </div>
                </td>
                <td className="px-6 py-4 text-black font-medium">Project A</td>
                <td className="px-6 py-4 text-black font-medium">
                  23 Nov 2022
                </td>
                <td className="px-2 py-4 w-[16rem] hover:bg-gray-100">
                  <SelectDropDown isAssigned={isAssigned} />
                </td>
                <td className="px-6 py-4 text-[#942A27] font-medium">Change</td>
                <td className="px-6 py-4 text-black font-medium">120 Days</td>
                <td className="px-6 py-4">
                  {tableRow % 2 == 0 ? (
                    <span className="bg-blue-100 text-blue-800 text-xs font-medium mr-2 px-2.5 py-1 rounded-md">
                      Ideation
                    </span>
                  ) : (
                    <span className="bg-purple-100 text-purple-800 text-xs font-medium mr-2 px-2.5 py-1 rounded-md">
                      Development
                    </span>
                  )}
                </td>
                <td className="px-6 py-4">
                  <div>
                    <button
                      className="py-2 px-2 rounded-lg hover:bg-gray-100"
                      onClick={(e) => {
                        e.stopPropagation();
                        setDialogOpen(index === dialogOpen ? null : index);
                      }}
                    >
                      <svg
                        width={18}
                        height={19}
                        viewBox="0 0 18 19"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M5.40078 9.7939C5.40078 10.2713 5.21114 10.7291 4.87357 11.0667C4.53601 11.4043 4.07817 11.5939 3.60078 11.5939C3.12339 11.5939 2.66555 11.4043 2.32799 11.0667C1.99042 10.7291 1.80078 10.2713 1.80078 9.7939C1.80078 9.31651 1.99042 8.85867 2.32799 8.5211C2.66555 8.18354 3.12339 7.9939 3.60078 7.9939C4.07817 7.9939 4.53601 8.18354 4.87357 8.5211C5.21114 8.85867 5.40078 9.31651 5.40078 9.7939ZM10.8008 9.7939C10.8008 10.2713 10.6111 10.7291 10.2736 11.0667C9.93601 11.4043 9.47817 11.5939 9.00078 11.5939C8.52339 11.5939 8.06556 11.4043 7.72799 11.0667C7.39042 10.7291 7.20078 10.2713 7.20078 9.7939C7.20078 9.31651 7.39042 8.85867 7.72799 8.5211C8.06556 8.18354 8.52339 7.9939 9.00078 7.9939C9.47817 7.9939 9.93601 8.18354 10.2736 8.5211C10.6111 8.85867 10.8008 9.31651 10.8008 9.7939ZM14.4008 11.5939C14.8782 11.5939 15.336 11.4043 15.6736 11.0667C16.0111 10.7291 16.2008 10.2713 16.2008 9.7939C16.2008 9.31651 16.0111 8.85867 15.6736 8.5211C15.336 8.18354 14.8782 7.9939 14.4008 7.9939C13.9234 7.9939 13.4656 8.18354 13.128 8.5211C12.7904 8.85867 12.6008 9.31651 12.6008 9.7939C12.6008 10.2713 12.7904 10.7291 13.128 11.0667C13.4656 11.4043 13.9234 11.5939 14.4008 11.5939Z"
                          fill="#6B7280"
                        />
                      </svg>
                    </button>
                    {index == dialogOpen && (
                      <div className="w-[8rem] flex flex-col border rounded shadow divide-y-2 bg-white z-50 absolute right-24 ">
                        {/* <div className="flex flex-col items-start gap-y-1 px-3 py-3">
                          <span className="text-gray-500 text-sm">Status</span>
                          <select
                            value="2"
                            className="w-full py-2 border-2 rounded-lg bg-gray-100"
                          >
                            <option value="2">Completed</option>
                            <option value="23">In Progress</option>
                          </select>
                        </div> */}
                        <span className="text-sm text-green-500 px-3 py-3">
                          Mark as Completed
                        </span>
                        <span className="text-sm text-blue-500 px-3 py-3">
                          Edit
                        </span>
                        <span className="text-sm text-red-500 px-3 py-3">
                          Delete
                        </span>
                      </div>
                    )}
                  </div>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default ProjectsTable;
